<template>
    <b-modal id="actions-modal" :hide-header="true" :hide-footer="true" :centered="true" ref="actions-modal">
        <div class="modal-body">
            <a href="#" role="button" class="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close"
               @click="hide()">
                <span aria-hidden="true">&times;</span>
            </a>
            <div>
                <h4>Edit variable payment</h4>
                <b-form @submit.prevent="submit" enctype="multipart/form-data">
                    <b-form-group label="Calender">
                        <b-select required v-model="model.employeeVariablePayCalender">
                            <b-select-option value="">Select calender</b-select-option>
                            <b-select-option v-for="cal in calenders" :value="cal.calenderDate" v-bind:key="cal.calenderDate">{{cal.calenderDate}}</b-select-option>
                        </b-select>
                    </b-form-group>
                    <b-form-group label="Item Name">
                        <b-input v-model="model.employeeVariablePayItem"/>
                    </b-form-group>
                    <b-form-group label="Amount">
                        <b-input v-model="model.employeeVariablePayItemAmount"/>
                    </b-form-group>
                    <b-form-group label="Exempt Tax">
                        <b-select v-model="model.employeeVariablePayItemTaxExempt">
                            <b-select-option value="YES">YES</b-select-option>
                            <b-select-option value="NO">NO</b-select-option>
                        </b-select>
                    </b-form-group>
                    <b-form-group label="Debit Account">
                      <b-select v-model="model.employeeVariablePayDebitAccount">
                        <b-select-option value="">Choose salary account</b-select-option>
                        <b-select-option v-for="account in modelAccounts" :value="account.accountNumber" v-bind:key="account.accountNumber">{{account.accountNumber}} - {{account.accountBankName}}</b-select-option>
                      </b-select>
                    </b-form-group>
                    <b-form-group label="Payment Type">
                        <b-select v-model="model.employeeVariablePayItemType">
                            <b-select-option value="EARNINGS">EARNINGS</b-select-option>
                            <b-select-option value="DEDUCTIONS">DEDUCTIONS</b-select-option>
                        </b-select>
                    </b-form-group>
                    <base-button title="Submit" :loading="isLoading"/>
                </b-form>
            </div>
        </div><!-- modal-body -->
    </b-modal>
</template>
<script>
    import { mapState } from "vuex"
    import BaseButton from "../button/BaseButton";
    export default {
        props:['show','row'],
        components:{BaseButton},
        name: 'ConfirmModal',
        data(){
            return{
                password: '',
                model:{
                    employeeVariablePayCalender: '',
                    employeeVariablePayItemAmount: '',
                    employeeVariablePayItem:'',
                    employeeVariablePayDebitAccount:'',
                    employeeVariablePayItemType:'',
                    employeeVariablePayItemTaxExempt:''
                },
                readType:'variablePayment/updateVariablePayments',
                editType:'variablePayment/editVariablePayment'
            }
        },
        methods:{
            hide() {
                this.$refs['actions-modal'].hide()
            },
            async submit(){
                await this.$store.dispatch(this.editType, this.model, {root: false});
                this.loadGrade();
                this.hide();
                let self = this;
                // eslint-disable-next-line no-unused-vars
                Object.keys(this.model).forEach(function(key,index) {
                    self.model[key] = '';
                });

            },
            gradeCode(){
                return  localStorage._gradeCode
            },
            loadGrade(){
                this.$store.dispatch(this.readType, {
                    readAll:'NO',
                    employerId: localStorage.orgId
                }, {root: false}).then()
            },
            hideauth: function () {
                this.password = '';
                this.$refs['actions-modal'].hide();
            },
            currentDate(){
                let date = new Date()
                date = this.$moment(date.toDateString()).format('YYYY-MM-DD')
                console.log(date)
                return date
            },
            loadCalender(){
                //this.$store.commit('calender/updateCalenderLoading',true)
                this.$store.dispatch("calender/updateCalenders", {
                    employerId: localStorage.orgId,
                    readAll:'YES'
                }, {root: false}).then()
            },
        },
        mounted() {
            //this.model = this.row
            this.loadCalender()
        },
        computed:{
            ...mapState(['grade','auth','variablePayment','calender']),
            isLoading(){
                return this.variablePayment.variablePaymentLoading
            },
            modelAccounts:{
              get(){
                console.log(this.$store.getters['auth/activeCompany'].accounts);
                return this.$store.getters['auth/activeCompany'].accounts
              },
              // set(val){
              //     this.model.accounts = val uploadModel
              // }
            },
            calenders(){
                return  this.calender.calenders
            },
        },
        watch: {
            show: function () {
                let self = this;
                // eslint-disable-next-line no-unused-vars
                Object.keys(this.row).forEach(function(key,index) {
                    self.model[key] = self.row[key];
                });
                if (this.row.employeeVariablePayId != null){
                    this.readType = 'variablePayment/updateVariablePayments';
                    this.editType = 'variablePayment/editVariablePayment';
                    this.model.id = this.row.employeeVariablePayId
                }
                this.$refs['actions-modal'].show()
            }
        },
    }
</script>
